<template>
  <div class="comm">
    <iframe :id="'comm-modal-'+modal.id_comunicado" />
    <div class="divider"></div>
    <div class="text-center">
      <Button layout="green-go" @click="readed()">OK</Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";

export default {
  name: "Comm",
  components: { Button },
  props: {
    modal: Object
  },
  mounted() {
    document
      .getElementById("comm-modal-" + this.modal.id_comunicado)
      .contentWindow.document.write(this.modal.content);
  },
  methods: {
    ...mapActions("general", ["COMM_READED"]),
    readed() {
      // Marcar como lido
      if (!this.modal.visualizado) this.COMM_READED(this.modal.id_comunicado);

      this.modal.show = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.comm {
  iframe {
    border: none;
    min-height: 600px;
    padding: 0 10px;
    @media (max-width: $small) {
      width: 100%;
    }

    @media (min-width: $medium) {
      width: 800px;
    }

    @media (min-width: $small) and (max-width: $medium) {
      width: 750px;
    }
  }
  .divider {
  }
  .button {
    width: 75px;
    margin: 10px;
  }
}
</style>